import * as FwDatas from "../FwDatas.ts";
import * as i18n from "../i18n.ts";
import * as modal from "../util/modal.ts";
import * as amplify from "../util/amplify.ts";
import * as DateUtils from "../lib/DateUtils.ts";
import * as Html from "../util/Html.ts";
import * as CustomInput from "../util/CustomInput.ts";
import {askCalendarUrl} from "../calendar/calendar_modal.ts";
import ApiServer from "../ApiServer.ts";

export{openCreateTimetable,openPickCreateTimetable,openEditTimetable}

function openEditTimetable(timetable: any): void {
  import("./timetable_edit.mustache").then(function(TPL_TIMETABLE){
    var theModal = modal.openDomModal(TPL_TIMETABLE,timetable);
    if(timetable.isOneTime){
      initFormOneTime(theModal,true)
    }else{
      initForm(theModal,true)
    }
  });
}
async function openPickCreateTimetable(): Promise<void> {
  var button = await modal.pick({
    title:"timetable.typetitle",
    gap:"var(--space-s)",
    button:[
      {title:"timetable.repeating_title",text:"timetable.repeating_description",emoji:'🔁',onclick:()=>Html.triggerbystring(null,'timetablecreate')},
      {title:"timetable.non_repeating_title",text:"timetable.non_repeating_description",emoji:'1️⃣',onclick:()=>Html.triggerbystring(null,'timetablecreate|oneTime')},
      {title:"timetable.import_title",text:"timetable.import_description",emoji:'🔗',onclick:()=>Html.triggerbystring(null,'timetablecreate|withUrl')},
    ]})
  if(button){
    button.onclick()
  }

}
async function openCreateTimetable(type: string): Promise<void> {
  var
    withUrl = type === "withUrl",
    isOneTime = withUrl || type === "oneTime",
    icalSubscriptionUrl: string | undefined;

  if(withUrl){
    icalSubscriptionUrl = await askCalendarUrl({title:'timetable.icssubscription'});
    if(!icalSubscriptionUrl) return
    var isGood = await new Promise((resolve,reject)=>{
      ApiServer.evtcalcheckurl(icalSubscriptionUrl!,resolve,reject)
    })
    if(!isGood){
      modal.oops("calendars.calbyurl.errortext");
      return;
    }

  }
  const TPL_TIMETABLE = await import("./timetable_edit.mustache")

  let
    userSettings = FwDatas.getSettingsPerFamily()||{},
    calendarFirstDayOfWeek = userSettings.calendarFirstDayOfWeek || DateUtils.getFirstDayOfWeek(),
    startDateLocale = DateUtils.getStartOfDay(new Date()),
    startDate = new Date(startDateLocale.toISOString().substring(0,19)+'Z');

  if(calendarFirstDayOfWeek===0) calendarFirstDayOfWeek = 7;
  var deltaFirstDayOfWeekDay = calendarFirstDayOfWeek - startDate.getDay();
  if(deltaFirstDayOfWeekDay>0){
    startDate = DateUtils.dateAdd(startDate,{day:deltaFirstDayOfWeekDay-7})
  }else{
    startDate = DateUtils.dateAdd(startDate,{day:deltaFirstDayOfWeekDay})
  }
  var finishDate = DateUtils.dateAdd(startDate,{week:52});
  var theModal = modal.openDomModal(TPL_TIMETABLE,{
    recurrencyDescriptor:{recurrencyInterval:1},
    //*emoji:'😀',
    startDate:startDate,
    finishDate:finishDate,
    calendarFirstDayOfWeek,
    isOneTime,
    icalSubscriptionUrl,
    rights:{canShare:true}
  })
  if(isOneTime){
    initFormOneTime(theModal,false)
  }else{
    initForm(theModal,false)
  }



}


function initForm(obj: HTMLElement, isEdit: boolean): void {
  const form = obj.querySelector("form") as HTMLFormElement;
  const startDateInput = form.startDate as HTMLInputElement;
  const firstDayOfWeekInput = form.calendarFirstDayOfWeek as HTMLInputElement | HTMLSelectElement;
  const currentWeekSelect = obj.querySelector("[name='currentWeek']") as HTMLSelectElement;
  const recurrencyIntervalInput = obj.querySelector("[name='recurrencyInterval']") as HTMLInputElement;
  const originalRecurrencyInterval = recurrencyIntervalInput.value;
  const firstOccurrenceOffset = obj.querySelector("[name='firstOccurrenceOffset']") as HTMLSelectElement;
  const originalFirstOccurrenceOffset = parseInt(firstOccurrenceOffset.value);

  if(firstDayOfWeekInput.nodeName==='SELECT'){
    firstDayOfWeekInput.innerHTML = DateUtils.getWeekDays().map((dayData: any)=>`<option value=${dayData.index}>${dayData.name}</option>`).join('');
  }

  function setFirstDayOfWeekValue(): void {
    var value = CustomInput.getDateValue(startDateInput as HTMLInputElement);
    (firstDayOfWeekInput as HTMLInputElement).value = String(value.getDay()===0?7:value.getDay());
  }
  setFirstDayOfWeekValue();
  startDateInput.addEventListener('change',setFirstDayOfWeekValue);

  firstDayOfWeekInput.addEventListener('change',function(){
    var originalDate = CustomInput.getDateValue(startDateInput as HTMLInputElement);
    originalDate.setDate(originalDate.getDate() - originalDate.getDay() + parseInt((firstDayOfWeekInput as HTMLInputElement).value)%7);
    CustomInput.setDateValue(startDateInput as HTMLInputElement, originalDate);
  });

  function initFirstOccurrenceOffset(): void {
    let
      weekCount = parseInt(recurrencyIntervalInput.value)||1,
      text = i18n.get(weekCount>4?'timetable.weeknumberN':('timetable.weeknumber'+weekCount),weekCount),
      firstOccurrenceOffsetValue = parseInt(firstOccurrenceOffset.value)||parseInt(firstOccurrenceOffset.getAttribute('data-value')) ||0;
    while(firstOccurrenceOffsetValue>(weekCount-1)){
      firstOccurrenceOffsetValue--;
    }
    const nextP = recurrencyIntervalInput.nextElementSibling as HTMLElement;
    if(nextP && nextP.tagName === 'P'){
      nextP.textContent = text;
    }
    if(weekCount===1){
      (firstOccurrenceOffset.parentElement as HTMLElement).style.display = 'none';
      firstOccurrenceOffset.innerHTML = `<option value="0" selected></option>`;
    }else{
      (firstOccurrenceOffset.parentElement as HTMLElement).style.display = '';
      let options: string[] = [];
      for(var i =0;i<weekCount;i++){
        options.push(i18n.get('timetable.week')+' '+String.fromCharCode(65+i))
      }
      firstOccurrenceOffset.innerHTML = options.map((o: string,idx: number)=>`<option value="${idx}" ${idx===firstOccurrenceOffsetValue?'selected':''}>${o}</option>`).join('');

      let currentWeek = (getCurrentWeekIndex() + firstOccurrenceOffsetValue + weekCount)%weekCount;
      currentWeekSelect.innerHTML = options.map((o: string,idx: number)=>`<option value="${idx}" ${idx===currentWeek?'selected':''}>${o}</option>`).join('');
    }
  }
  recurrencyIntervalInput.addEventListener('change',initFirstOccurrenceOffset);
  initFirstOccurrenceOffset();

  function setFirstOccurrenceOffsetFromCurrentWeek(): void {
    let weekCount = parseInt(recurrencyIntervalInput.value);
    firstOccurrenceOffset.value = String((parseInt(currentWeekSelect.value)-getCurrentWeekIndex()+ weekCount)%weekCount);
  }
  currentWeekSelect.addEventListener('change',setFirstOccurrenceOffsetFromCurrentWeek);
  if(currentWeekSelect){
    startDateInput.addEventListener('change',setFirstOccurrenceOffsetFromCurrentWeek);
  }

  function getCurrentWeekIndex(): number {
    var
      weekCount = parseInt(recurrencyIntervalInput.value),
      startDate = CustomInput.getDateValue(startDateInput as HTMLInputElement),
      firstWeekEndDate = DateUtils.dateAdd(startDate,{day:7}),
      endDate = DateUtils.dateAdd(startDate,{week:weekCount}),
      currentWeekSeeker = new Date(),
      deltaWeekCount = 0;

    //firt of all we position our crawler in the range
    while(currentWeekSeeker<startDate){
      currentWeekSeeker = DateUtils.dateAdd(currentWeekSeeker,{week:weekCount});
    }
    while(currentWeekSeeker>endDate){
      currentWeekSeeker = DateUtils.dateAdd(currentWeekSeeker,{week:-weekCount});
    }
    //then we seek in which week it is
    while(currentWeekSeeker>firstWeekEndDate){
      deltaWeekCount++;
      currentWeekSeeker = DateUtils.dateAdd(currentWeekSeeker,{week:-1});
    }
    return deltaWeekCount;

  }
  ApiServer['custom.evttimetableput'] = function(form: any): void {
    function doit(): void {
      ApiServer.evttimetableput.prepare({allowDeleteEvent:true})(obj,afterPutBuilder(obj,isEdit))
    }
    if(isEdit && originalRecurrencyInterval>recurrencyIntervalInput.value){
      var
        weeks = ['A','B','C','D','E','F','G','H','I','J','K','L','M'].slice(0,parseInt(originalRecurrencyInterval as string)),
        text: string;
      //reorder weeks according to originalFirstOccurrenceOffset
      weeks.splice(0,0,...weeks.splice(originalFirstOccurrenceOffset,150))
      //remove after new count
      weeks.splice(0,parseInt(recurrencyIntervalInput.value))

      if(weeks.length>1){
        text = i18n.get('timetable.educationnalreduceweeks',{a:weeks.slice(0,weeks.length-1).join(', '),b:weeks[weeks.length-1]});
      }else{
        text = i18n.get('timetable.educationnalreduceweek',{a:weeks[weeks.length-1]});
      }

      modal.ask({
        title:'new_confirm_action.title',
        message:text,
        lottie:"images/lottie/face_with_monocle.json",
        button:[
          {title:'actions.yesdelete',class:'negative',onclick:doit},
          {title:'actions.cancel',class:"secondary",onclick:function(){
            recurrencyIntervalInput.value = originalRecurrencyInterval;
          }},
          ]
      })
    }else{
      doit()
    }

  }
}

function initFormOneTime(formModal: HTMLElement, isEdit: boolean): void {
  const form = formModal.querySelector("form") as HTMLFormElement;
  const firstDayOfWeekInput = form.calendarFirstDayOfWeek as HTMLInputElement | HTMLSelectElement;

  if(firstDayOfWeekInput.nodeName==='SELECT'){
    firstDayOfWeekInput.innerHTML = ( DateUtils.getWeekDays().map((day: any)=>`<option value=${day.index}>${day.name}</option>`).join(''));
  }
  firstDayOfWeekInput.value  = firstDayOfWeekInput.getAttribute('data-value')
  ApiServer['custom.evttimetableput'] = ApiServer.evttimetableput.prepare({allowDeleteEvent:true},afterPutBuilder(formModal,isEdit))
}

function afterPutBuilder(formModal: HTMLElement, isEdit: boolean): (freshTimetable: any) => Promise<void> {
  return async function(freshTimetable: any): Promise<void> {
    modal.closeDomModal(formModal)
    if(!isEdit){
      await modal.simple({
        title:"timetable.createdtitle",
        message:"timetable.createdmessage",
        lottie:"images/lottie/anim_verified_check.json",
        button:"actions.start"
      });
      
    }
    amplify.publish('timetableUpdated',freshTimetable)
    
  }
}
